import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import OpenMakulerModalStandardButton from "../../Common/IleggelseClient/OpenMakulerModalStandardButton";
import MakulerModalContainer from "../../Common/MakulerModalContainer";
import KopiContainer from "../../Common/Miljogebyr/Detalj/KopiContainer";
import PrintOut from "../../Common/PrintOut";
import EndreMiljogebyrContainer from "./ButtonPanelButtons/EndreMiljogebyrContainer";
import GodkjennContainer from "./ButtonPanelButtons/GodkjennContainer";
import NyEttersendelseContainer from "./ButtonPanelButtons/NyEttersendelseContainer";
import OpphevMakuleringContainer from "./ButtonPanelButtons/OpphevMakuleringContainer";
import SendTilIneContainer from "./ButtonPanelButtons/SendTilIneContainer";
import SendTilSvarUtContainer from "./ButtonPanelButtons/SendTilSvarUtContainer";

import {
  getMiljogebyr as getMiljogebyrAction,
  getMiljogebyrerHistorikk as getMiljogebyrerHistorikkAction,
} from "../../../actions/miljogebyrerActions";
import {
  getMiljoMakuleringer as getMiljoMakuleringerAction,
  postMiljoMakulering as postMiljoMakuleringAction,
} from "../../../actions/miljoMakuleringerActions";

import { bypatruljen } from "../../../constants/roles";
import { authorized } from "../../../utils/authorizationUtils";
import { getMostRecentObjectComparedOnParameter } from "../../../utils/date";

export default function ButtonsContainer({ miljogebyrId }) {
  const dispatch = useDispatch();
  const miljogebyr = useSelector((state) => state.miljogebyr);
  const miljogebyrEttersendelser = useSelector(
    (state) => state.miljogebyrEttersendelser,
  );

  const authorizedSaksbehandler = authorized([
    bypatruljen.saksbehandler,
    bypatruljen.saksbehandleradmin,
  ]);

  const latestEttersendelse = useMemo(
    () =>
      miljogebyrEttersendelser && miljogebyrEttersendelser.length > 0
        ? getMostRecentObjectComparedOnParameter(
            miljogebyrEttersendelser,
            "ettersendelseDato",
          )
        : null,
    [miljogebyrEttersendelser],
  );

  const reloadHistorikk = async () => {
    await dispatch(getMiljogebyrerHistorikkAction(miljogebyrId));
  };

  const postMiljoMakulering = (id, kommentar) =>
    dispatch(postMiljoMakuleringAction(id, kommentar))
      .then(() => {
        dispatch(getMiljogebyrAction(id));
        dispatch(getMiljoMakuleringerAction(id));
        reloadHistorikk();
      })
      .catch(() => Promise.reject(false));

  const showMakuler = () =>
    !miljogebyr.isMakulert &&
    !miljogebyr.isBetalingsfristUtlopt &&
    !miljogebyr.isSendtKemner; // Skal stå isSendtKemner tils backend er endret til isSendtIne

  return (
    <section
      className="detalj-miljogebyr-section-margin no-print"
      style={{ height: 40 }}
    >
      {miljogebyr && miljogebyr.id === miljogebyrId && (
        <>
          <div className="pull-left">
            <KopiContainer />
            <PrintOut />
          </div>
          <div className="pull-right">
            {authorizedSaksbehandler && showMakuler() && (
              <MakulerModalContainer
                id={miljogebyr.id}
                titleType="miljøgebyr"
                ileggelsesnummer={miljogebyr.ileggelsesnummer}
                openMakulerModal={OpenMakulerModalStandardButton}
                postMakulering={postMiljoMakulering}
              />
            )}
            {authorizedSaksbehandler && (
              <OpphevMakuleringContainer reloadHistorikk={reloadHistorikk} />
            )}
            {authorizedSaksbehandler && <SendTilIneContainer />}
            {authorizedSaksbehandler && (
              <SendTilSvarUtContainer
                latestEttersendelseId={
                  latestEttersendelse && latestEttersendelse.id
                }
                reloadHistorikk={reloadHistorikk}
              />
            )}
            {authorizedSaksbehandler && (
              <GodkjennContainer reloadHistorikk={reloadHistorikk} />
            )}
            {authorizedSaksbehandler && (
              <NyEttersendelseContainer reloadHistorikk={reloadHistorikk} />
            )}
            {authorizedSaksbehandler && <EndreMiljogebyrContainer />}
          </div>
        </>
      )}
    </section>
  );
}
